import { BuscarCcbsEmpregadorParams, BuscarCobrancaPropostaParams, BuscarVinculosEmpregadorParams, BuscarVinculosEncerradosParams, Contato, ICancelarBoletoCobrancaRetorno, IGerarBoletosCobrancaRequest, IGerarBoletosCobrancaRetorno, IGerarRelatorioQuitacaoRequest, IHistoricoNotificacoesCcbRetorno, INegociacao, INovoVinculoCobranca, IRelatorioQuitacaoRetorno, IRelatorioSituacaoParcelasRetorno, IReprocessarCobrancasRequest, IReprocessarCobrancasRetorno, IResumoFinanceiroCobrancaRetorno, IVinculosAtivosEmpregadorRetorno, IVinculosEmpregadorRetorno, IVinculosEncerradosRetorno, IComprovanteDesligamentoGeradoRetorno, ISeguroNegociacaoCreate, ISeguroNegociacaoUpdate, ISeguroNegociacaoRetorno, ICobrancaRelatorio, IRenegotiationRequest, IRenegotiationSimulationResponse, IRenegotiationStatusResponse, ReenviarNotificacaoResponse } from "@/models/consignado/proposal-billings.model";
import {
  IAtualizarContatoRequest,
  IAtualizarEnderecoRequest,
  IAtualizarNegociacaoRequest,
  IContatosCobrancaRetorno,
  ICriarContatoRequest,
  IEnderecoCobrancaRetorno,
  ParteContatoCobranca,
} from "@/models/consignado/proposal-billings.model";
import { axiosConsignadoInstance } from "../axiosInstance";

export const buscarPropostaCobrancasRelatorios = async (
  params: BuscarCobrancaPropostaParams
): Promise<ICobrancaRelatorio[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/relatorios`,
      {
        params: {
          ...params,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar o relatório das cobranças", error);
    throw error;
  }
};

export const buscarDetalheCobranca = async (id: string) => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${id}`
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar detalhe da cobrança:", error);
    throw error;
  }
};

export const adicionarContatoCobranca = async (body: ICriarContatoRequest): Promise<Contato> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/proposta/contatos`, body
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar contato da cobrança", error);
    throw error;
  }
};

export const deletarContatoCobranca = async (id: string): Promise<Contato> => {
  try {
    const response = await axiosConsignadoInstance.delete(`/api-consignado-trabalhador/v1/proposta/contatos/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao deletar contato da cobrança", error);
    throw error;
  }
};

export const adicionarNegociacaoCobranca = async (cobrancaId: string, body: INegociacao): Promise<INegociacao> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${cobrancaId}/negociacoes`, body
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar negociacao da cobrança", error);
    throw error;
  }
};

export const deletarNegociacaoCobranca = async (id: string) => {
  try {
    const response = await axiosConsignadoInstance.delete(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/negociacoes/${id}`,
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao deletar negociacao da cobrança", error);
    throw error;
  }
};

// ── HIS-024 (backend his-adm-cobranca-020 `efab7a1f`) — seções Negociação
// (TAR-048) e Dados de Contato (TAR-049) do detalhe da CCB. Todas as rotas
// abaixo aceitam número da CCB ou id da cobrança no `:id`
// (findByIdOrNumeroCcb); o redesign manda o número da CCB.

// GET /cobrancas/:ccb/negociacoes — histórico completo da CCB, de todas as
// competências, mais recentes primeiro (a rota antiga era por competência).
export const buscarNegociacoesPorCcb = async (numeroCcb: string): Promise<INegociacao[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${numeroCcb}/negociacoes`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar negociações da cobrança", error);
    throw error;
  }
};

// PUT /cobrancas/negociacoes/:id — só os campos enviados são alterados.
export const atualizarNegociacaoCobranca = async (
  id: string,
  body: IAtualizarNegociacaoRequest
): Promise<INegociacao> => {
  try {
    const response = await axiosConsignadoInstance.put(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/negociacoes/${id}`,
      body
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar negociação da cobrança", error);
    throw error;
  }
};

// GET /cobrancas/:ccb/contatos — tomador e empregador resolvidos a partir da
// cobrança, cada um com nome, documento, endereço e contatos filtrados por
// tipo. Substitui, no redesign, as duas chamadas GET /contatos?referenciaId.
// Também é de onde o redesign tira o `cobranca_id` (o `ccb.id` da listagem é
// o id do vínculo, não da cobrança).
export const buscarContatosPorCcb = async (numeroCcb: string): Promise<IContatosCobrancaRetorno> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${numeroCcb}/contatos`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar contatos da cobrança", error);
    throw error;
  }
};

// PUT /contatos/:id — só os campos enviados são alterados; o backend limpa a
// máscara do telefone.
export const atualizarContatoCobranca = async (
  id: string,
  body: IAtualizarContatoRequest
): Promise<Contato> => {
  try {
    const response = await axiosConsignadoInstance.put(
      `/api-consignado-trabalhador/v1/proposta/contatos/${id}`,
      body
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar contato da cobrança", error);
    throw error;
  }
};

// PUT /cobrancas/:ccb/contatos/:parte/endereco — endereço do tomador ou do
// empregador (tela de admin: endereço editável). Cria o endereço se a parte
// ainda não tiver um. Devolve o endereço salvo.
export const atualizarEnderecoCobranca = async (
  numeroCcb: string,
  parte: ParteContatoCobranca,
  body: IAtualizarEnderecoRequest
): Promise<IEnderecoCobrancaRetorno> => {
  try {
    const response = await axiosConsignadoInstance.put(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${numeroCcb}/contatos/${parte}/endereco`,
      body
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar endereço da cobrança", error);
    throw error;
  }
};


// Global, não por CCB: o processamento por CCB (/proposta/:ccb/cobrancas/processar)
// foi desligado no backend em his-adm-cobranca-020 `c940bf02`. O período vai na
// query string, não no body — é como o backend lê (`@Query()`).
export const reprocessarCobrancas = async (
  params: IReprocessarCobrancasRequest
): Promise<IReprocessarCobrancasRetorno> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/ingerir-e-processar-dados-brutos`,
      undefined,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao reprocessar cobranças", error);
    throw error;
  }
};

export const buscarNovosVinculos = async (
  documento: string
): Promise<INovoVinculoCobranca[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/novos-vinculos`,
      {
        params: { documento },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar novos vínculos:", error);
    throw error;
  }
};

// Nível 1 (empregadores) — REAL. Paginação + filtros server-side.
// GET /proposta/cobrancas/empregadores/vinculos-ativos (backend his-adm-cobranca-020).
export const buscarVinculosEmpregadores = async (
  params: BuscarVinculosEmpregadorParams
): Promise<IVinculosEmpregadorRetorno> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/empregadores/vinculos-ativos`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar vínculos ativos agrupados por empregador", error);
    throw error;
  }
};

// Seções "Resumo Financeiro" e "Parcelas" do detalhe da CCB — REAL.
// GET /proposta/cobrancas/:ccb/resumo-financeiro (backend his-adm-cobranca-020,
// TAR-ADM-cobranca-038): devolve os agregados + `parcelas` (com escrituração,
// repasse, divergência e boletos por parcela) numa rota só, pra vínculo ativo
// e encerrado. O backend dispara o sync com a BMP na 1ª chamada se ainda não
// tiver os dados.
export const buscarResumoFinanceiroCobranca = async (
  numeroCcb: string
): Promise<IResumoFinanceiroCobrancaRetorno> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${numeroCcb}/resumo-financeiro`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar resumo financeiro da cobrança", error);
    throw error;
  }
};

// TAR-ADM-cobranca-041 (backend his-adm-cobranca-020 `7bcfad0c`). Gera o PDF
// na hora (consulta a BMP) e devolve a URL. dataInicio/dataFim opcionais, em
// yyyy-MM-dd, filtram pelo vencimento da parcela. Erros já vêm com `message`
// para o operador: 400 (período inválido), 422 (BMP sem conteúdo), 503 (BMP fora).
export const gerarRelatorioSituacaoParcelas = async (
  numeroCcb: string,
  dataInicio?: string,
  dataFim?: string
): Promise<IRelatorioSituacaoParcelasRetorno> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${numeroCcb}/relatorio-situacao-parcelas`,
      { params: { dataInicio, dataFim } }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao gerar relatório de situação das parcelas", error);
    throw error;
  }
};

// TAR-ADM-cobranca-043 (backend his-adm-cobranca-020 `65a9ba13`) — REAL.
// Consulta o valor atualizado das parcelas na BMP pra `data_calculo`, gera o
// PDF e devolve a URL. Erros já vêm com `message` pro operador: 400 (data ou
// parcela inválida), 422 (BMP sem cálculo), 503 (BMP fora).
export const gerarRelatorioQuitacao = async (
  numeroCcb: string,
  body: IGerarRelatorioQuitacaoRequest
): Promise<IRelatorioQuitacaoRetorno> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${numeroCcb}/relatorio-quitacao`,
      body
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao gerar relatório de quitação", error);
    throw error;
  }
};

// TAR-ADM-cobranca-050 (backend his-adm-cobranca-020 `72c3b158`) — REAL.
// Histórico de notificações da CCB inteira (competências + contrato), lista
// plana da mais recente pra mais antiga. 400 sem CCB, 404 cobrança inexistente.
// Só lê a tabela `notificacoes`: contrato antigo (envios só em
// dispatch_notifications_info) volta `total: 0`, não é erro.
export const buscarHistoricoNotificacoesPorCcb = async (
  numeroCcb: string
): Promise<IHistoricoNotificacoesCcbRetorno> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${numeroCcb}/historico-notificacoes`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar histórico de notificações da cobrança", error);
    throw error;
  }
};

// POST /notificacoes/:id/reenviar (módulo de notificação, `616911d7`) — REAL.
// Reenvia pelo id da notificação (UUID v4). O HTTP reflete o resultado: 200
// tudo enviado, 207 parcial, 502 tudo falhou (o axios lança nos 502; o 207
// resolve e o chamador olha `status` de cada canal).
export const reenviarNotificacao = async (
  notificacaoId: string
): Promise<ReenviarNotificacaoResponse> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/notificacoes/${notificacaoId}/reenviar`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao reenviar notificação", error);
    throw error;
  }
};

// TAR-045 (backend his-adm-cobranca-020 `8fbfa26c`) — REAL. Gera cobrança
// (boleto/PIX) na BMP pras parcelas selecionadas, numa chamada só. Só
// `parcelas` é obrigatório; o resto sobrescreve os defaults do servidor. O
// boleto NÃO vem na resposta: fica disponível em `disponivel_em_segundos` e
// entra em `parcelas[].boletos[]` do resumo financeiro quando a rotina de
// baixa (TAR-047) sincronizar — o chamador invalida
// ["resumo-financeiro-cobranca", ccb]. Erros já vêm com `message` pro
// operador (ver IBoletoCobrancaErroRetorno): 409 COBRANCA_ATIVA,
// 422 ESCRITURACAO_BLOQUEIA_COBRANCA (CON_002/CON_003), 400, 403 (ADMIN),
// 404, 503.
export const gerarBoletosCobranca = async (
  numeroCcb: string,
  body: IGerarBoletosCobrancaRequest
): Promise<IGerarBoletosCobrancaRetorno> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${numeroCcb}/boletos`,
      body
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao gerar boletos da cobrança", error);
    throw error;
  }
};

// TAR-045 — REAL. Cancela a cobrança na BMP pelo `codigo_liquidacao`
// (== `boletos[].codigoCobranca`). 409 JA_CANCELADO / BOLETO_PAGO, 404, 422, 503.
export const cancelarBoletoCobranca = async (
  numeroCcb: string,
  codigoLiquidacao: string
): Promise<ICancelarBoletoCobrancaRetorno> => {
  try {
    const response = await axiosConsignadoInstance.delete(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${numeroCcb}/boletos/${encodeURIComponent(codigoLiquidacao)}`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao cancelar boleto da cobrança", error);
    throw error;
  }
};

// Nível 2 — CCBs ativas de um CNPJ, lidas de cobranca_clt. REAL.
// GET /proposta/cobrancas/empregador/:cnpj/vinculos-ativos (TAR-054, backend
// his-adm-cobranca-020). Paginada e com os mesmos filtros do nível 1.
export const buscarCcbsAtivasPorEmpregador = async (
  cnpj: string,
  params: BuscarCcbsEmpregadorParams
): Promise<IVinculosAtivosEmpregadorRetorno> => {
  try {
    const digitos = (cnpj ?? "").replace(/\D/g, "");
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/empregador/${digitos}/vinculos-ativos`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar CCBs ativas do empregador", error);
    throw error;
  }
};

// GET /proposta/cobrancas/vinculos-encerrados (HIS-ADM-cobranca-029, backend
// his-adm-cobranca-020). Lista plana por CCB, paginada, com a elegibilidade ao
// seguro já classificada; `recorte` filtra pelo mesmo SQL da classificação.
export const buscarVinculosEncerrados = async (
  params: BuscarVinculosEncerradosParams
): Promise<IVinculosEncerradosRetorno> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/vinculos-encerrados`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar vínculos encerrados", error);
    throw error;
  }
};


export const buscarSeguroNegociacoes = async (cobrancaId: string): Promise<ISeguroNegociacaoRetorno[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${cobrancaId}/seguros/negociacoes`
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar negociações de seguro:", error);
    throw error;
  }
};

export const criarSeguroNegociacao = async (
  cobrancaId: string,
  body: ISeguroNegociacaoCreate
): Promise<ISeguroNegociacaoRetorno> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${cobrancaId}/seguros/negociacoes`,
      body
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao criar negociação de seguro:", error);
    throw error;
  }
};

export const atualizarSeguroNegociacao = async (
  negociacaoId: string,
  body: ISeguroNegociacaoUpdate
): Promise<ISeguroNegociacaoRetorno> => {
  try {
    const response = await axiosConsignadoInstance.put(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/seguros/negociacoes/${negociacaoId}`,
      body
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar negociação de seguro:", error);
    throw error;
  }
};

export const deletarSeguroNegociacao = async (negociacaoId: string): Promise<void> => {
  try {
    await axiosConsignadoInstance.delete(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/seguros/negociacoes/${negociacaoId}`
    );
  } catch (error) {
    console.error("Erro ao deletar negociação de seguro:", error);
    throw error;
  }
};

export const gerarComprovanteDesligamento = async (
  id: string
): Promise<IComprovanteDesligamentoGeradoRetorno> => {
  try {
    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/proposta/cobrancas/${id}/comprovante-desligamento`
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao gerar comprovante de desligamento:", error);
    throw error;
  }
};

export const simularRenegociacaoEmprestimo = async (
  body: IRenegotiationRequest
): Promise<IRenegotiationSimulationResponse> => {
  const response = await axiosConsignadoInstance.post(
    `/api-consignado-trabalhador/v1/proposta/cobrancas/renegociacao/simular`,
    body
  );

  return response.data;
};

export const gerarPropostaRenegociacao = async (
  body: IRenegotiationRequest
): Promise<void> => {
  await axiosConsignadoInstance.post(
    `/api-consignado-trabalhador/v1/proposta/cobrancas/renegociacao/gerar-proposta`,
    body
  );
};

export const realizarAverbacaoRenegociacao = async (
  proposalId: string
): Promise<void> => {
  await axiosConsignadoInstance.post(
    `/api-consignado-trabalhador/v1/proposta/cobrancas/renegociacao/${proposalId}/realizar`
  );
};

export const buscarStatusRenegociacao = async (
  proposalId: string
): Promise<IRenegotiationStatusResponse> => {
  const response = await axiosConsignadoInstance.get(
    `/api-consignado-trabalhador/v1/proposta/cobrancas/renegociacao/${proposalId}/status`
  );

  return response.data;
};
